// Toggles the agent conversation sidebar (#agent-sidebar) open/closed and
// persists the choice in localStorage so it survives reloads and navigation.
// The sidebar defaults to OPEN when nothing is stored. The hook lives on the
// toggle button (#sidebar-toggle); it drives the sidebar width and swaps the
// two hamburger icons to match.
const STORAGE_KEY = "agent-sidebar-open";

function apply(open) {
  const sidebar = document.getElementById("agent-sidebar");
  const iconOpen = document.getElementById("sidebar-icon-open");
  const iconClosed = document.getElementById("sidebar-icon-closed");
  if (!sidebar) return;

  sidebar.classList.toggle("w-72", open);
  sidebar.classList.toggle("w-0", !open);
  sidebar.classList.toggle("overflow-hidden", !open);
  if (iconOpen) iconOpen.classList.toggle("hidden", !open);
  if (iconClosed) iconClosed.classList.toggle("hidden", open);
}

function stored() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === null ? true : value === "true";
  } catch {
    return true;
  }
}

// Applies the stored open/closed preference to #agent-sidebar on mount. Lives on
// the sidebar itself so pages that render the shared sidebar WITHOUT the toggle
// button (Personas/Skills) still honor the collapse choice instead of snapping
// back open.
export const SidebarRestore = {
  mounted() {
    apply(stored());
  },
};

export const AgentSidebar = {
  mounted() {
    apply(stored());

    this.handleClick = () => {
      const sidebar = document.getElementById("agent-sidebar");
      const next = !(sidebar && sidebar.classList.contains("w-72"));
      apply(next);
      try {
        localStorage.setItem(STORAGE_KEY, next ? "true" : "false");
      } catch {
        // localStorage may be unavailable (e.g. private mode); ignore.
      }
    };

    this.el.addEventListener("click", this.handleClick);
  },

  destroyed() {
    this.el.removeEventListener("click", this.handleClick);
  },
};
